import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { Field } from "../../models/field";
import {PrintDocument} from "../../models/print-document";
import Helpers from "../../utils/helpers";

@Injectable()
export class PrintDocumentControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getHistoryPage(docId: string, page: number): Observable<any[]> {
    return this.http.get(this.baseUrl + "print-documents/" + docId + "/pagedhistory?pageNo=" + page + "&pageSize=12") as Observable<any[]>;
  }

  public getDocumentList(serviceId: string, showForms: boolean): Observable<PrintDocument[]> {
    if (showForms) {
      return this.http.get(this.baseUrl + "service/" + serviceId + "/print-documents?showForms=true") as Observable<PrintDocument[]>;
    } else {
      return this.http.get(this.baseUrl + "service/" + serviceId + "/print-documents") as Observable<PrintDocument[]>;
    }
  }
  public getActiveDocumentList(serviceId: string): Observable<PrintDocument[]> {
    return this.http.get(this.baseUrl + "/service/" + serviceId + "/active-print-documents/?all=true") as Observable<PrintDocument[]>;
  }

  public getPrintDocument(docId: string): Observable<PrintDocument> {
    return this.http.get(this.baseUrl + "print-documents/" + docId) as Observable<PrintDocument>;
  }

  public saveDocument(doc: PrintDocument) {
    Helpers.trimRecursiveObj(doc);
    const body = JSON.stringify(doc);
    return this.http.put(this.baseUrl + "print-documents/" + doc.id, body, { responseType: "text" });
  }
  public createDocument(serviceId: string, document: PrintDocument) {
    Helpers.trimRecursiveObj(document);
    const body = JSON.stringify(document);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/print-documents", body) as Observable<PrintDocument>;
  }

  public deleteDocument(docId: string) {
    return this.http.delete(this.baseUrl + "print-documents/" + docId, { responseType: "text" });
  }

  public updateSortOrder(docs: PrintDocument[]) {
    const body = JSON.stringify(docs);
    return this.http.put(this.baseUrl + "sortprintdocuments", body, {responseType: "text"});
  }

  public generateDefaultApplicantForm(serviceId: string, fields: Field[]) {
    Helpers.trimRecursiveObj(fields);
    const body = JSON.stringify(fields);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/applicant-form/generate", body);
  }

  public getTemplatesList() {
    return this.http.get(this.baseUrl + "available-print-templates");
  }

  public getTemplateSchema(templateId: string, serviceId: string) {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/print-template/" + templateId);
  }

  public getPreviewUrl(docId: string) {
    return this.http.get(this.baseUrl + "print-documents/generate-preview/" + docId, {responseType: "text"});
  }

  // Get form schema for preview only (GET request)
  public getFormSchemaForRevision(docId: string, revisionNumber: string): Observable<any> {
    return this.http.get(this.baseUrl + "print-documents/" + docId + "/history/" + revisionNumber + "/schema") as Observable<any>;
  }

  // Revert form to a specific revision (PUT request - triggers cleanup of orphaned relations)
  // Note: Backend endpoint has typo "revison_number" (missing 'i')
  public revertFormToRevision(docId: string, revisionNumber: string): Observable<any> {
    return this.http.put(this.baseUrl + "print-documents/" + docId + "/history/" + revisionNumber, null, {responseType: "text"}) as Observable<any>;
  }

}
